import React from "react";
import { Modal, Button, Form } from "react-bootstrap";
import { Formik } from "formik";

import "./PopUpModel.css";

const PopupModal = ({ show, onClose, formFields, onSubmit, initialValues, validationSchema, title }) => {
  return (
    <Modal 
      show={show} 
      onHide={onClose} 
      centered 
      fullscreen={true}
      dialogClassName="custom-modal"
    >
      <Modal.Header closeButton className="modal-header-custom">
        <Modal.Title className="modal-title-custom">{title}</Modal.Title>
      </Modal.Header>
      <Modal.Body className="modal-body-custom">
        <Formik
          initialValues={initialValues}
          validationSchema={validationSchema}
          onSubmit={(values) => {
            onSubmit(values);
            onClose();
          }}
        >
          {({ handleSubmit }) => (
            <Form onSubmit={handleSubmit}>
              {formFields.map((FieldComponent, index) => (
                <FieldComponent key={index} />
              ))}
              <div className="text-center">
                <Button variant="primary" type="submit" className="mt-3 modal-submit-btn">
                  Submit
                </Button>
              </div>
            </Form>
          )}
        </Formik>
      </Modal.Body>
    </Modal>
  );
};

export default PopupModal;
